import { render, staticRenderFns } from "./rendering.vue?vue&type=template&id=494d859f&scoped=true"
import script from "./rendering.vue?vue&type=script&lang=js"
export * from "./rendering.vue?vue&type=script&lang=js"
import style0 from "./rendering.vue?vue&type=style&index=0&id=494d859f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494d859f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('494d859f')) {
      api.createRecord('494d859f', component.options)
    } else {
      api.reload('494d859f', component.options)
    }
    module.hot.accept("./rendering.vue?vue&type=template&id=494d859f&scoped=true", function () {
      api.rerender('494d859f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/insuranceManage/mainFrom/rendering.vue"
export default component.exports